import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,

  environment: import.meta.env.VITE_ENV || import.meta.env.MODE,

  sendDefaultPii: false,

  integrations: [
    Sentry.browserTracingIntegration(),
  ],

  tracesSampleRate: 1.0,

  enabled: true, // 👈 IMPORTANT (forces it in dev)
});